export const getBadges = state => {
  return state.badges
}

export const getBadgeById = state => id => {
  return state.badges.find(el => el.id === id)
}